import React from 'react';
import ContentHubCompatibleLoaders from '../productCompatibleLoaderListing/components/compatibleLoaders';
import { TCHCompatibleLoadersProps } from '../productCompatibleLoaderListing/types/productCompatibleLoaderListing.types';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import {
  descriptionKeyModelCompatibleAttachments,
  eyebrowKeyModelCompatibleAttachments,
  titleKeyModelCompatibleAttachments,
} from '../../constants/dictionary.constants';

const ProductModelCompatibleAttachmentListing = (props: TCHCompatibleLoadersProps): JSX.Element => {
  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <ContentHubCompatibleLoaders
      {...props}
      seeMoreKey={'cnhi-seeMoreAttachments'}
      seeLessKey={'cnhi-seeLessAttachments'}
      id={props?.rendering?.componentName}
      eyebrowKeyCompatibleLoaders={eyebrowKeyModelCompatibleAttachments}
      titleKeyCompatibleLoaders={titleKeyModelCompatibleAttachments}
      descriptionKeyCompatibleLoaders={descriptionKeyModelCompatibleAttachments}
    />
  );
};

export default ProductModelCompatibleAttachmentListing;
